<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode">驻京美食</li>
            </ul>
            <div class="page-main">
                <div class="page-content">
                    <h3>驻京美食</h3>
                    <div class="filter">
                        <div class="filter-area">
                            <span class="filter-label">行政划区</span>
                            <el-radio-group v-model="area" size="small" @input="changeArea()">
                                <el-radio-button v-for="mapArea in mapAreaList" :key="mapArea.value" :label="mapArea.value">{{ mapArea.value }}</el-radio-button>
                            </el-radio-group>
                        </div>
                        <div class="filter-cuisine">
                            <span  class="filter-label">地方菜系</span>
                            <el-radio-group v-model="cuisine" size="small" @input="changeCuisine()">
                                <el-radio-button  v-for="cookingStyle in cookingStyleList" :key="cookingStyle.value" :label="cookingStyle.value">{{ cookingStyle.value }}</el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <ul class="food-list">
                        <li class="food-item"  v-for="food in foodList" :key="food.Id"  @click="goDetail(food)">
                            <img :src="food.ImageUrl" />
                            <div class="food-item-btm">
                                <h4>{{ food.Title }}</h4>
                                <p class="food-tag ellipsis_one"><span v-for="tag in food.tagList" :key="tag">{{ tag }}</span></p>
                                <p class="food-price">{{ food.AvgPrice }}<i> /人</i></p>
                                <div class="food-contact">
                                    <p>电话：{{ food.Tel }}</p>
                                    <p class="ellipsis_two">地址：{{ food.HomeAddress }} </p>
                                </div>
                            </div>
                        </li>
                        <!-- <li class="food-item">
                            <img src ="@/assets/image/association/trends1.png" />
                            <div class="food-item-btm">
                                <h4>五湖四海青年路豪华院子</h4>
                                <p  class="food-tag"><span>空调开放</span><span>有包间</span><span>川湘菜</span></p>
                                <p class="food-price">100<i> /人</i></p>
                                <div class="food-contact">
                                    <p>电话：010-64463984</p>
                                    <p class="ellipsis_two">地址：北京市东城区和平里九区甲4号5栋401 </p>
                                </div>
                            </div>
                        </li> -->
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        :current-page="currentPage"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getFoodArea,
    getFoodCookingStyle,
    getFoodList
} from '@services/indexService.js'

export default {
    name:"",
    data() {
        return {
            cuisine:'全部',
            mapAreaList: [
                {
                    "label": 'all',
                    "value": '全部',
                }
            ],
            cookingStyleList: [
                {
                    "label": 'all',
                    "value": '全部', 
                }
            ],
            area:'全部',
            currentPage: 1,
            pageSize: 12,
            foodList: [],
            total: 100,
        }
    },
    created() {
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
        }
       this.getFoodCookingStyle();
       this.getFoodArea();
       this.getFoodList();
    },
    methods: {
        getFoodArea() {
            getFoodArea().then(res => {
                console.log(res);
                if (res.Code == 1) {
                    Object.keys(res.Data).forEach(key => {
                        this.mapAreaList.push({
                            "label": key,
                            "value": res.Data[key],
                        });
                    });
                } else {
                    this.$message.error("区域请求失败");
                }
            })
        },
        getFoodCookingStyle() {
            getFoodCookingStyle().then(res => {
                console.log(res);
                if (res.Code == 1) {
                    Object.keys(res.Data).forEach(key => {
                        this.cookingStyleList.push({
                            "label": key,
                            "value": res.Data[key],
                        });
                    });
                } else {
                    this.$message.error("cookingStyleList请求失败");
                }
            })
        },
        getFoodList() {
            let param = {
                current: this.currentPage,
                size: this.pageSize,
            };
            if (this.area !== '全部') {
                param.IsTop = this.area;
            }
            if (this.cuisine !== '全部') {
                param.IsHome = this.cuisine;
            }
            getFoodList(param).then(res => {
                // console.log(res);
                if (res.Code == 1) {
                    this.total = res.Count;
                    this.foodList = res.Data;
                    this.foodList.map( item => {
                        if (item.SubTitle) {
                            item.tagList = item.SubTitle.split(",");
                        }
                    })
                } else {
                    this.$message.error("美食请求失败");
                }
            })
        },
        changeArea() {
            this.currentPage = 1;
            this.getFoodList();
        },
        changeCuisine () {
            this.currentPage = 1;
            this.getFoodList();
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getFoodList();
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/city-food-detail',
                query: {
                    id: data.Id,
                    page: this.currentPage,
                }
            });
            window.open(newUrl.href, '_blank');
        }
    }
}
</script>

<style scoped>
.page-content {
    width: 1280px;
    padding: 30px;
}
.page-content h3{
    text-align:center;
}
.filter-area,
.filter-cuisine{
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}
.filter-label {
    height:30px;
    line-height: 30px;
    font-size: 14px;
    color:#000;
    font-weight:bold;
    margin-right: 30px;
    display: block;
    flex-shrink: 0;
}
.food-list{
    padding-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.food-list .food-item:nth-child(3n){
    margin-right:0;
}
.food-item {
    width: 390px;
    margin-bottom: 20px;
    margin-right: 25px;
    cursor:pointer;
}
.food-item img {
    width: 390px;
    height: 196px;
    display: block;
}
.food-item-btm{
    padding: 10px;
    padding-bottom: 20px;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    height: 220px;
}
.food-item-btm h4 {
    color: #262626;
    font-size: 18px;
}
.food-contact {
    border-top: 1px solid #E5E5E5;
    color: #6A6A6A;
    font-size: 14px;
    padding-top:10px;
}
.food-tag {
    margin-bottom: 5px;
    height: 30px;
}
.food-tag span{
    background: #0090F0;
    font-size: 12px;
    color: #fff;
    padding: 2px 4px;
    margin-right: 10px;
}
.food-item-btm h4:hover {
    color: #116EBA;
}
</style>